import React from 'react';
import PropTypes from 'prop-types';
import DashboardModal from 'containers/dashboard/DashboardModal';
import withTranslation from 'decorators/i18n';

const MaxAgeModal = ({ visible, onClose, i18n }) => (
  <DashboardModal
    visible={visible}
    onClose={onClose}
    title={i18n.t('dashboard|maxAgeModalTitle')}
    body={i18n.t('dashboard|maxAgeModalDescription')}
  />
);

MaxAgeModal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
};

MaxAgeModal.defaultProps = {
  visible: false,
};

export default withTranslation()(MaxAgeModal);
